import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import api, { handleApiError } from "../../helpers/api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const RecentOrders = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [sort, setSort] = useState("-createdAt");

    const fetchOrders = async (sortOption) => {
        try {
            const res = await api.get("/orders", {
                params: { sort: sortOption },
            });
            setOrders(res.data.data || []);
        } catch (err) {
            handleApiError(err, dispatch, navigate);
            setOrders([]);
        }
    };

    useEffect(() => {
        fetchOrders(sort);
    }, [sort, dispatch, navigate]);

    const handleSortChange = (newSort) => {
        setSort(newSort);
    };

    // Map status to badge classes
    const getStatusClass = (status) => {
        switch (status) {
            case "pending": return "badge-soft-warning";
            case "processing": return "badge-soft-info";
            case "shipped": return "badge-soft-primary";
            case "delivered": return "badge-soft-success";
            case "cancelled": return "badge-soft-danger";
            default: return "badge-soft-secondary";
        }
    };

    return (
        <React.Fragment>
            <Col>
                <Card>
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Recent Orders</h4>
                        <div className="flex-shrink-0 d-flex gap-2">
                            <UncontrolledDropdown className="card-header-dropdown" direction="start">
                                <DropdownToggle tag="a" className="text-reset" role="button">
                                    <span className="fw-semibold text-uppercase fs-12">Sort by: </span>
                                    <span className="text-muted">{sort === "-createdAt" ? "Newest" : "Oldest"}<i className="mdi mdi-chevron-down ms-1"></i></span>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem onClick={() => handleSortChange("-createdAt")}>Newest</DropdownItem>
                                    <DropdownItem onClick={() => handleSortChange("createdAt")}>Oldest</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>

                        </div>
                    </CardHeader>

                    <CardBody>
                        <div className="table-responsive table-card">
                            <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                                <thead className="text-muted table-light">
                                <tr>
                                    <th scope="col">Refrence</th>
                                    <th scope="col">Customer</th>
                                    <th scope="col">Order Date</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                {(orders || []).map((item, key) => (
                                    <tr key={key}>
                                        <td>
                                            <Link to={`/apps-ecommerce-order-details/${item._id}`} className="fw-medium link-primary">{item.reference}</Link>
                                        </td>
                                        <td>
                                            <div className="flex-grow-1">
                                                {item.user ? `${item.user.firstname} ${item.user.lastname}` : "N/A"}
                                            </div>
                                        </td>
                                        <td>
                                            {new Date(item.createdAt).toLocaleDateString()}
                                        </td>
                                        <td>
                                            <span className="text-success">DT {item.totalPrice.toFixed(2)}</span>
                                        </td>
                                        <td>
                                            <span className={getStatusClass(item.status)}>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}</span>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default RecentOrders;